export function AchievementsPage() {
   return (
      <div>
         <h1>Achievements</h1>
         <p>Achievements page content</p>
      </div>
   );
}
